<app-share-button ></app-share-button>
<div class="row">
    <div class="col-md-8  ScrollStyle-1">
        <div class="card crd p-3">
            <div class="row">
                <div class="col-md-10 col10 mt-2">
                    <h2>Price Match</h2>
                </div>
                <div class="col-md-2 col2"> <a href="javascript:void(0)" (click)="openShareOptions()"> <button class="btn share"><img src="./assets/share (5).svg" style="width: 30px;" (click)="menues('share-button')"
                    alt=""> </button> </a>  
                </div>
                <!-- <div class="col-md-12" (mouseover)="showpayment(true,'1')"
                (mouseout)="showpayment(false,'1')" id="1">
                <div
                    style="max-width: 100%; overflow: hidden; padding-bottom: 56.25%; position: relative;">
    
                    <iframe class="i-frame" src="https://www.youtube.com/embed/5kY7ApMM9Uo"
                        title="YouTube video player" frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        allowfullscreen></iframe>
                </div>    -->

                <div class="col-md-12" (mouseover)="showpayment(true,'2')" (mouseout)="showpayment(false,'2')" id="2">
                    <label for="" class="mt-4">We're excited to introduce a game-changing feature for your customers:
                        PayG's Price Match. Now, shoppers can confidently enjoy the best prices on your products by
                        matching them to competitors. Here's why this feature is a game-changer for both you and your
                        customers:</label>

                </div>
                <div class="col-md-12" (mouseover)="showpayment(true,'3')" (mouseout)="showpayment(false,'3')" id="3">
                    <h2 class="mt-3">How PayG's Price Match Works: </h2>

                    <label for="" class="mt-4"><b> Competitive Advantage: &nbsp;</b>Empower your customers to compare
                        prices across different stores, ensuring they get the best deal.</label>
                    <label for="">Stand out in the market by offering a transparent and customer-centric approach to
                        pricing.</label>


                    <label for="" class="mt-4"><b>Enhanced Customer Confidence: &nbsp;</b> Build trust with your
                        audience by allowing them to shop with confidence, knowing they won't miss out on better deals
                        elsewhere.</label>


                    <label for="" class="mt-4"><b> Seamless Integration: &nbsp;</b>Our Price Match feature seamlessly
                        integrates into your checkout process, providing a hassle-free experience for customers.</label>


                    <label for="" class="mt-4"><b>Customer Loyalty: &nbsp;</b>Reward customer loyalty by assuring them
                        that you're committed to offering the most competitive prices in the market.</label>


                    <label for="" class="mt-4"><b>Attract New Customers: &nbsp;</b> Use Price Match as a powerful
                        marketing tool to attract new customers looking for the best value for their money.</label>
                </div>
                <div class="col-md-12" (mouseover)="showpayment(true,'4')" (mouseout)="showpayment(false,'4')" id="4">
                    <h2 class="mt-4">
                        Benefits for Your Customers:
                    </h2>
                    <label class="mt-3" for=""><b> Savings Assurance:&nbsp;</b>Customers can confidently make purchases,
                        knowing they're getting the best possible price for your high-quality products. </label>
                    <label class="mt-3" for=""><b> Streamlined Process:&nbsp;</b> Our user-friendly interface makes it
                        easy for customers to compare and match prices without any complications.

                    </label>
                    <label class="mt-3" for=""><b>Real-Time Updates: &nbsp;</b>Prices are dynamically adjusted in
                        real-time, ensuring accuracy and reflecting the latest market conditions.</label>

                    <label class="mt-3" for=""><b>Transparent Shopping Experience: &nbsp;</b>Demonstrate transparency
                        and fairness, fostering positive customer perceptions and repeat business.</label>
                    <label for="">Get ready to revolutionize your customers' shopping experience with PayG's Price Match
                        feature. </label>
                </div>
            </div>
        </div>
    </div>
    <div class="col-md-4 hide-tbl content2 ">
        <div class="card crd p-4">
            <div class="row">
                <div class="col-md-12">
                    <h5>
                        Table of Contents:
                    </h5>

                </div>
                <div class="col-md-12 mt-2">
                    <!-- <a href="#1">
                        <div class="row">
                            <div class="col-md-2"> <img src="./assets/video.svg" class="tab-icon intro"
                                    alt=""> &nbsp;</div>
                            <div class="col-md-10">
                                <span class="videoHover" style="cursor: pointer;"
                                    [ngClass]="{'video':colors=='1'}" (click)="color('1')"
                                    >
                                    Introduction to
                                    Payment Gateways
                                </span>
                              
                            </div>
                        </div>
                    </a> -->
                </div>
                <div class="col-md-12 ">
                    <a href="#2">
                        <div class="row">
                            <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro" alt=""> &nbsp;</div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="textHover" [ngClass]="{'text':colors=='2'}"
                                    (click)="color('2')"> Introduction to Price Match </span>

                            </div>
                        </div>
                    </a>
                </div>
                <div class="col-md-12 ">
                    <a href="#3">
                        <div class="row">
                            <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro" alt=""> &nbsp;</div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="textHover" [ngClass]="{'text':colors=='3'}"
                                    (click)="color('3')"> How it works? </span>

                            </div>
                        </div>
                    </a>
                </div>
                <div class="col-md-12 ">
                    <a href="#4">
                        <div class="row">
                            <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro" alt=""> &nbsp;</div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="textHover" [ngClass]="{'text':colors=='4'}"
                                    (click)="color('4')"> Benefits of using Price Match </span>

                            </div>
                        </div>
                    </a>
                </div>
            </div>
        </div>
    </div>
    <div class="col-md-9 hide ft-9">
        <hr>
        <div class=" row crd">
            <div class="col-md-8" style="width:70%">
                <a [routerLink]="['/coupons']"> <button class="btn btn-color"> <img src="./assets/Arrow 3.svg"
                            alt="">&nbsp;&nbsp;Coupons
                    </button></a>

            </div>
            <div class="col-md-4        " style="width:30%">
                <a [routerLink]="['/settlement']"> <button class="btn btn-color">Settlement Split
                        &nbsp;<img src="./assets/Arrow 2 1.svg" alt=""></button></a>
            
            </div>  
        </div>
    </div>
</div>
